// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__1RbwK","default":"logo_default__1oVxK","footer":"logo_footer__2hDG7"};